export enum PaymentTypeEnum {
    CYCLE = 10,
    HOUR  = 20,
    TON   = 30
}